<template>
  <div class="info-carousel-data">
    <h2 class="widget-title">{{ settings.value.show_title_block }}</h2>

    <div class="content">
      <VueperSlides
              ref="slider"
              :pauseOnHover="false"
              :touchable="false"
              :arrows="false"
              :bullets="true"
              :duration="settings.value.auto_scroll_interval"
              :fixed-height="fixedHeight"
              :autoplay="settings.value.use_auto_scroll"
      >
        <template v-for="(slide, i) in settings.value.carousel_elements">
          <VueperSlide
                  class="w-100 h-100 slide"
                  v-if="slide.is_active"
                  :key="i"
          >
            <template v-slot:content>
              <div class="slide-item" v-html="slide.value"></div>
            </template>
          </VueperSlide>
        </template>
      </VueperSlides>
    </div>
  </div>
</template>

<script>
    import { VueperSlides, VueperSlide } from "vueperslides";
    import "vueperslides/dist/vueperslides.css";
    import "../../ej2-richtexteditor.scss";

    import { mapGetters } from "vuex";
    import widgetHelper from "@/mixins/widgetHelper";

    export default {
        mixins: [widgetHelper],
        components: {
            VueperSlides,
            VueperSlide
        },
        computed: {
            ...mapGetters(["streams"]),
        },
        data() {
            return {
                fixedHeight: "100%",
            };
        },
        mounted() {},
    };
</script>

<style lang="scss">
  .info-carousel-data{
    padding-top: 10px;
    height: 100%;
    display: flex;
    flex-direction: column;

    .content{
      padding-top: 10px;
      background: linear-gradient(to right, rgba(2, 18, 18, 0.6) 0, rgba(99, 99, 99, 0.6) 49%, rgba(33, 33, 33, 0.6) 100%);
      flex: 1 1 auto;
    }

    .vueperslides{
      height: 100%;

      .slide-item{
        padding: 15px;
        height: auto;
        box-sizing: border-box;

        &:after{
          content: '';
          display: table;
          clear: both;
        }
      }
    }

    .vueperslides__parallax-wrapper:before,
    .vueperslides__parallax-wrapper:after{
      box-shadow: none!important;
    }

    .vueperslides__parallax-wrapper{
      height: calc(100% - 40px);
    }

    .vueperslides__bullets{
      position: relative;

      .vueperslides__bullet{
        margin: 14px 7px;
      }
    }
  }
</style>
